import { getStore, setStroe } from '@/util/util.js'
import store from '@/store/index.js'
import FingerprintJS from '@fingerprintjs/fingerprintjs'

const fpPromise = FingerprintJS.load()

// // 生成随机数
// function guid() {
//   return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
// }
// // 适用于app获取UUID
// function getuuid() {
//   return (guid() + guid() + guid() + guid() + guid() + guid() + guid());
// }
// 设置设备ID
export function setDeviceId() {
  return new Promise((resolve) => {
    let isDeviceId = false;
    try {
      const value = getStore({
        name: 'DeviceId',
        type: 'session'
      });
      if (value && (value + "").length > 3) {
        isDeviceId = true;
        resolve()
      }
    } catch (e) {
      // error
    }
    // 如果没有DeviceId
    if (!isDeviceId) {
      fpPromise
        .then((fp) => fp.get())
        .then((result) => {
          // vm.$u.vuex("BetDeviceId", result.visitorId);
          console.log( result.visitorId,' result.visitorId');
          let id =  result.visitorId
          store.commit('setDeviceId', id)
          setStroe({
            name: "DeviceId",
            content: id,
            type: 'session'
          })
          resolve()
        });
    }
  })
}


